<button
  odxButton
  variant="secondary"
  (click)="toggleLock()"
  [disabled]="(hasWritePermission$ | async) === false"
  [odxTooltip]="setToolTipText()"
  [odxTooltipOptions]="{ position: isSingleItem ? 'top' : 'bottom' }"
>
  <odx-icon [name]="locked ? 'lock' : 'unlock'" size="medium"></odx-icon>
</button>
